'use strict';

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.component('winresScheduleWeek', {
    // Note: This component is currently so simple it doesn't need a controller.
    // The bindings below are accessed directly as $ctrl.foo and so on.
    template: require('./winresScheduleWeek.html'),
    bindings: {
        // List of days of the week.
        // Format: { title: "Mon 27", items: [ ... ] }
        days: '<',

        // Event that triggers when a schedule item is clicked. Parameters:
        // - day: The day of the item
        // - item: The item
        onClick: '&'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresScheduleWeek/winresScheduleWeek.js
// module id = 485
// module chunks = 2